<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12v4irh/tc-custom/9781504089340.jpg?1728726076325" alt="This image is the cover for the book How Midsummer Night"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">How Midsummer Night
      </h1>
      <p class="bookDescription body article font2">
        <b>The author chronicles the final months of the life of her close friend and fellow teacher, in this unique and unforgettable memoir.</b><br/><br/> When fifty-six-year-old Richard is diagnosed with glioblastoma, a rare and inoperable brain cancer, his colleague and friend Janet Somerville begins to document his life in a personal, months-long letter to him, to one day share with his wife and daughters. Teaching together at a Toronto boys’ school, Janet and Richard bonded over their love of musical theater and literature. And now that Richard is nearing his end, it is these memories that comfort both of them through the good days and the bad.<br/><br/> Peppered with theatrical references and inside jokes—from Shakespeare to Rodgers and Hammerstein, Monty Python to <i>Avenue Q</i>—the letter offers a touching glimpse into Richard’s life. During his treatment, Janet shares with him the day-to-day activities of the school, including the unfiltered witticisms that fall from the mouths of teenage boys. Together they recollect stories of school choir trips, plays directed, and books read. Richard’s positive attitude—his playfulness and graciousness—shines through the pages.<br/><br/><i>How Midsummer Night </i>is a beautiful tribute to a man who made his mark on his family and the community around him—a man who was so much more than just another teacher, so much more than just another friend.<br/><br/> “A wonderful memoir with an odd title.” —Stephen King
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Janet Somerville
      </h2>
      
      <p class="authorDescription body article"> Janet Somerville taught literature for twenty years. Her book about pioneering war correspondent Martha Gellhorn, <I>Yours, for Probably Always</I>, was a Book of the Day for the<I> Guardian</I> and named by <I>Quill &amp; Quire</I> as one of the best books of 2019.<BR /><BR /> Somerville lives in Toronto, contributes frequently to the <I>Toronto Star </I>book pages, and interviews authors on stage. She can be reached at www.janetsomervillewriter.com and on Twitter @janetsomerville. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?25f62856